module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded bg-success-lighten-2"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "inline": ""
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.ag.name),
      callback: function($$v) {
        _vm.$set(_vm.ag, "name", $$v)
      },
      expression: "ag.name"
    }
  }), _vm._v(" "), _c('select-structure', {
    staticStyle: {
      "width": "40%"
    },
    model: {
      value: (_vm.struct),
      callback: function($$v) {
        _vm.struct = $$v
      },
      expression: "struct"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 56
    }
  }, [_c('el-col', {
    staticClass: "bg-success-lighten-1 side-bar",
    staticStyle: {
      "padding-bottom": "1.5em"
    },
    attrs: {
      "span": 2
    }
  }, [_c('b', {
    staticClass: "text-muted"
  }, [_vm._v("Tables")]), _vm._v(" "), _c('el-menu', {
    staticClass: "inherit-bg",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "default-active": "1",
      "collapse": ""
    },
    on: {
      "select": _vm.addToFormula
    }
  }, _vm._l((_vm.menu), function(m, index) {
    return _c('el-submenu', {
      key: index,
      attrs: {
        "index": m.value
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: m.icon
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(m.label))])]), _vm._v(" "), _vm._l((m.group), function(g, index) {
      return _c('el-menu-item-group', {
        key: index,
        attrs: {
          "title": g.label
        }
      }, _vm._l((g.children), function(mm) {
        return _c('el-menu-item', {
          key: mm.value,
          attrs: {
            "index": mm.value
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(mm.label)
          }
        })])
      }), 1)
    })], 2)
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('h4', [_vm._v("Formula Area")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "1.5em"
    },
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, _vm._l((_vm.operators), function(op, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "align": "center"
      }
    }, [_c('el-button', {
      attrs: {
        "size": "large",
        "plain": "",
        "round": "",
        "type": op.type,
        "disabled": _vm.disabled(op)
      },
      on: {
        "click": function($event) {
          return _vm.addToFormula(op)
        }
      }
    }, [_vm._v(_vm._s(op.op))])], 1)
  }), 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    attrs: {
      "id": "formula-box",
      "gutter": 8
    }
  }, [(_vm.formula.length === 0) ? _c('i', {
    staticClass: "text-muted text-center"
  }, [_vm._v("Drop your operators and fields here")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.formula), function(fn, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": _vm.calcSpan(fn),
        "align": "center"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": fn.text + (fn.table ? ' from ' + fn.table + ' table' : ''),
        "placement": "bottom"
      }
    }, [_c('span', {
      staticClass: "formula",
      class: fn.class
    }, [(fn.table) ? _c('span', [_vm._v(_vm._s(fn.table) + " ")]) : _vm._e(), _vm._v(_vm._s(fn.text))])])], 1)
  })], 2), _vm._v(" "), (_vm.opCount > 0) ? _c('span', [_vm._v(_vm._s(_vm.opCount + ' bracket' + (_vm.opCount > 1 ? 's' : '') + ' open'))]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Clear the formula"
    }
  }, [(_vm.formula.length > 0) ? _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "text",
      "icon": "fa fa-eraser"
    },
    on: {
      "click": function($event) {
        return _vm.clearFormula()
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.formula.length > 0) ? _c('el-row', [_c('hr'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n      Select Example Site: "), _c('select-site', {
    attrs: {
      "no-form": ""
    },
    model: {
      value: (_vm.site),
      callback: function($$v) {
        _vm.site = $$v
      },
      expression: "site"
    }
  }), _vm._v(" "), (_vm.site) ? _c('div', [_c('h4', [_vm._v("Example:")]), _vm._v(" "), (_vm.tableData.length > 0 && _vm.tableData[0].field1) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "field1",
      "label": "Field1",
      "width": "123"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "op",
      "label": "Operator"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "field2",
      "width": "123",
      "label": "Field 2"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "result",
      "width": "123",
      "label": "Result"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a44410f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/AgreementsBuilder.vue
// module id = 1514
// module chunks = 0